<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-tag"></i> 系统管理
                </el-breadcrumb-item>
				<el-breadcrumb-item>路由管理</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
			<div class="handle-box">
				<el-input class="handle-input mr10"
					placeholder="输入关键字进行过滤"
					v-model="filterText">
				</el-input>&nbsp;
				<el-button type="primary" icon="el-icon-lx-add" class="handle-del mr10" @click="handleAdd">添加记录</el-button>
				<el-button size="small" type="primary" icon="el-icon-folder-add" @click="handleBatchAdd">批量添加</el-button>
			</div>
			<el-table
				:data="dataSource.filter(data => !filterText || data.title.toLowerCase().includes(filterText.toLowerCase()) || data.name.toLowerCase().includes(filterText.toLowerCase()))"
				style="width: 100%;margin-bottom: 20px;"
				row-key="id"
				border
				size="medium"
				:tree-props="{children: 'children', hasChildren: 'hasChildren'}">
				<el-table-column
				  prop="title"
				  label="路由名称"
				  width="280">
				  <template slot-scope="scope">
					<span :class="scope.row.icon" v-if="scope.row.icon" style="width:20px"></span>
					<span v-if="scope.row.icon==null" style="margin-left:15px; width:20px"></span>{{ scope.row.title }}
				  </template>
				</el-table-column>
				<el-table-column
				  prop="name"
				  label="路由标识"
				  width="280">
				</el-table-column>
				<el-table-column
				  prop="value"
				  label="内容">
				</el-table-column>
				<el-table-column label="操作" width="180" align="right">
					<template slot-scope="scope">
						<el-button
							type="text"
							icon="el-icon-arrow-up"
							@click="move(scope.row, -1)"
							v-if="scope.row.sortKey > 0 && scope.row.routeType != 2"
						></el-button>
						<el-button
							type="text"
							icon="el-icon-arrow-down"
							@click="move(scope.row, 1)"
							v-if="scope.row.brotherSize - 1 > scope.row.sortKey && scope.row.routeType != 2"
						></el-button>
						<el-button
							type="text"
							icon="el-icon-lx-add"
							@click="append(node, scope.row)"
							v-if="scope.row.routeType != 2"
						>新增</el-button>
						<el-button
							type="text"
							icon="el-icon-delete"
							class="red"
							@click="remove(node, scope.row)"
						>删除</el-button>
					</template>
				</el-table-column>
			</el-table>
			
			<!--
            <el-tree
			  :data="dataSource"
			  node-key="id"
			  :expand-on-click-node="false"
			  :show-checkbox="false"
			  :filter-node-method="filterNode"
			  style="border:1px solid #eee; margin-top:20px;width:100%;"
			  ref = "tree"
			>
			<template #default="{ node, data }">
				<span class="custom-tree-node">
					<span :class="data.icon" v-if="data.icon" style="width:50px">{{ data.title }}</span>
					<span v-if="data.icon==null" style="margin-left:15px; width:50px">{{ data.title }}</span>
					<span>{{data.name}}</span>
					<span>{{data.value}}</span>
					<span>
						<el-button
                            type="text"
                            icon="el-icon-lx-add"
                            @click="append(node, data)"
							v-if="data.routeType != 2"
                        >新增</el-button>
                        <el-button
                            type="text"
                            icon="el-icon-delete"
                            class="red"
                            @click="remove(node, data)"
                        >删除</el-button>
					</span>
				</span>
			</template>
			</el-tree>
			-->
        </div>

        <!-- 编辑弹出框 -->
        <el-dialog v-dialogDrag :close-on-click-modal=false title="添加路由" :visible.sync="editVisible" width="30%">
            <el-form ref="form" :model="form" label-width="80px" :rules="rules">
				<el-form-item label="父节点" prop="parentId" v-if="form.parentId">
					<el-input v-model="form.parentName" readonly=true></el-input>
                    <el-input v-model="form.parentId" style="display:none"></el-input>
                </el-form-item>
				<el-form-item label="路由类型" prop="routeType" v-if="form.parentRouteType == 1 || form.parentRouteType == 3">
					<el-input v-model="form.routeTypeName" readonly=true></el-input>
                    <el-input v-model="form.routeType" style="display:none"></el-input>
                </el-form-item>
                <el-form-item label="路由类型" prop="routeType" v-if="form.parentId == undefined || form.parentRouteType == 0">
					<el-select v-model="form.routeType" placeholder="请选择路由类型">
						<el-option key="" label="请选择" value=""></el-option>
						<el-option v-for="item in routeTypeKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
					</el-select>
                </el-form-item>
                <el-form-item label="图标" prop="icon">
                    <el-input v-model="form.icon"></el-input>
                </el-form-item>
				<el-form-item label="索引" prop="name">
                    <el-input v-model="form.name"></el-input>
                </el-form-item>
				<el-form-item label="标题" prop="title">
                    <el-input v-model="form.title"></el-input>
                </el-form-item>
				<el-form-item label="url" prop="value">
                    <el-input v-model="form.value"></el-input>
                </el-form-item>
            </el-form>  
            <span slot="footer" class="dialog-footer">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveEdit" v-prevent-re-click>确 定</el-button>
            </span>
        </el-dialog>
		
		
		
		<!-- 编辑弹出框 -->
        <el-dialog v-dialogDrag :close-on-click-modal=false title="批量添加" :visible.sync="batchVisible" width="60%">
            <el-input type=textarea :rows=22 v-model="batch" placeholder="路由格式(路由类型,图标,索引,标题,子路由)"></el-input>
            <span slot="footer" class="dialog-footer">
				<el-button @click="batchVisible = false">取 消</el-button>
				<el-button type="primary" @click="saveBatch">保存</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { getAuthorityRouteTreeData, saveAuthorityRoute, deleteAuthorityRoute, getAuthorityRoute, saveAuthorityRouteBatch, updateAuthorityRouteSort} from '../../../api/index';
export default {
    name: 'AuthorityRoute',
    data() {
        return {
            dataSource: [],
            editVisible: false,
            form: {},
			rules: {
                name: [{ required: true, message: '请输入索引', trigger: 'blur' }],
				title: [{ required: true, message: '请输入标题', trigger: 'blur' }]
            },
			previewData:{},
			uuid:"",
			previewVisible:false,
			fileList:[],
			filterText:"",
			currentData:{},
			batch:[],
			batchVisible:false,
			routeTypeKV:[{"key":0, "value":"菜单分组路由"},{"key":1, "value":"页面路由"},{"key":3, "value":"独立路由"}]
        };
    },
    created() {
        this.getData();
    },
	//watch: {
	//	filterText(val) {
	//		this.$refs.tree.filter(val);
	//	}
    //},
    methods: {
		findKey(obj, key) {
			if (typeof obj !== 'object') {
				return
			}
			var ret = false;
			var data;
			for(var i=0; i<obj.length; i++) {
				if (obj[i].routeType == 2) {
					continue;
				}
				if (obj[i].id == key) {
					return true;
				} else {
				    ret = this.findKey(obj[i].children, key)
					if (ret) {
						data = obj[i].children;
						break;
					}
				}
			}
			return data;
		},
		move(row, step) {
			let obj = this.findKey(this.dataSource, row.id);
			let sortKeys = [];
			if (obj) {
				let sortKey = row.sortKey + step;
				for (var i = 0; i < obj.length; i++) {
					if (obj[i].sortKey == sortKey) {
						let item = {};
						item["id"] = obj[i].id;
						item["sortKey"] = obj[i].sortKey - step;
						obj[i].sortKey = item["sortKey"];
						sortKeys.push(item);
					} else {
						let item = {};
						item["id"] = obj[i].id;
						item["sortKey"] = obj[i].sortKey;
						sortKeys.push(item);
					}
				}
				
				let item = {};
				item["id"] = row.id;
				item["sortKey"] = sortKey;
				row.sortKey = sortKey;
				sortKeys.push(item);
				
				updateAuthorityRouteSort(sortKeys).then(res => { 
				if (res.code == 0 ) {
					this.getData();
				} else {
					this.$message.error("刷新排序失败！" + res.message);
				}
            });
			}
			
		},
		//节点过滤
		filterNode(value, data) {
			if (!value) return true;
			return data.title.indexOf(value) !== -1;
		},
        // 获取树形结构数据
        getData() {
            getAuthorityRouteTreeData().then(res => { 
				if (res.code == 0 ) {
					this.dataSource = res.data;
				} else {
					this.$message.error("获取数据失败！" + res.message);
				}
            });
        },
        // 删除操作
        remove(node, data) {
            // 二次确认删除
			let confirmStr = '确定要删除 ' + data.title + ' 吗？';
			if (data.children.length > 0) {
				confirmStr = data.title + '有子节点，删除会同步清除，确定要删除 ' + data.title + ' 吗？';
			}
            this.$confirm(confirmStr, '提示', {
                type: 'warning'
            })
                .then(() => {
					let ids = [];
					this.getIds(ids, data);
					deleteAuthorityRoute(ids).then(res => {
						if (res.code == 0) {
							this.$message.success('删除成功');
							const parent = node.parent;
							const children = parent.data.children || parent.data;
							const index = children.findIndex((d) => d.id === data.id);
							children.splice(index, 1);
						} else {
							this.$message.error(`删除失败！` + res.message);
						}
					});
                })
                .catch(() => {});
        },		
		getIds(ids, data) {
			ids.push(data.id);
			if (data.children) {
				for(let i = 0; i < data.children.length; i++) {
					this.getIds(ids, data.children[i]);
				}
			}
		},		
		//添加操作
		handleAdd() {
			this.form = {};
			this.$set(this.form, "parentId", undefined);
			this.$set(this.form, "parentRouteType", undefined);
			this.$set(this.form, "parentName", undefined);
			this.currentData = undefined;
			this.editVisible = true;
		},		
		handleBatchAdd() {
			this.batch = [];
			this.batchVisible = true;
		},
        // 保存编辑
        saveEdit() {
			this.$refs.form.validate(valid => {
				if (valid) {
					saveAuthorityRoute(this.form).then(res => {
						if (res.code == 0) {
							this.$message.success('保存成功！');
							this.editVisible = false;
							if (this.currentData == undefined) {
								this.dataSource.push(res.data);
							} else {
								if (!this.currentData.children) {
									this.$set(this.currentData, 'children', []);
								}
								this.currentData.children.push(res.data);
							}
						} else {
							this.$message.error(`保存失败！` + res.message);
						}
					})
				} else {
					this.$message.error('数据信息不完整！');
				}
			});
        },
		saveBatch() {
			if (this.batch === "" || this.batch === "[]") {
				this.$message.error(`请输入路由`);
				return;
			}
			let routes = []
			try {
				routes = JSON.parse(this.batch);
				if (routes.length == 0) {
					this.$message.error(`请输入至少输入一条路由`);
					return;
				}
			} catch(err) {
				this.$message.error(`路由数据格式错误`);
				return;
			}			
			saveAuthorityRouteBatch(routes).then(res => {
				if (res.code == 0) {
					this.getData();
					this.$message.success('保存成功！');
					this.batchVisible = false;
				} else {
					this.$message.error(`保存失败！` + res.message);
				}
			})
		},
		append(node, data) {
			this.form = {};
			this.$set(this.form, "parentId", data.id);
			this.$set(this.form, "parentRouteType", data.routeType);
			this.$set(this.form, "parentName", data.title);
			if (data.routeType === 1 || data.routeType === 3) {
				this.$set(this.form, "routeType", "2");
				this.$set(this.form, "routeTypeName", "按钮路由");
			}
			this.editVisible = true;
			this.currentData = data;
		},
		uploadSuccess(response, file, fileList) {
			if (response.code == 0 ) {
				this.previewData = response.data.obj;
				this.uuid = response.data.uuid;
				this.previewVisible = true;
			} else {
				this.$message.error(response.message);
			}
		}
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
.record-a-d {
	float:left; 
	padding-top:20px;
}

.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}
</style>